var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60179 11.3984C1.26943 10.6396 1.61516 9.75498 2.37399 9.42263L13.9426 4.35576C14.7014 4.0234 15.586 4.36912 15.9183 5.12796L18.477 10.9699C18.8094 11.7287 18.4637 12.6133 17.7048 12.9457L6.13626 18.0126C5.37743 18.3449 4.49284 17.9992 4.16048 17.2404L1.60179 11.3984Z",
    fill: "#8D33FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89842 13.4165C5.56606 12.6576 5.91179 11.7731 6.67062 11.4407L18.2392 6.37382C18.998 6.04146 19.8826 6.38719 20.215 7.14602L22.7737 12.988C23.106 13.7468 22.7603 14.6314 22.0015 14.9638L10.4329 20.0306C9.67406 20.363 8.78947 20.0173 8.45711 19.2584L5.89842 13.4165Z",
    fill: "#FF8833"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_2091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 18,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02281 13.362C5.69045 12.6032 6.03618 11.7186 6.79501 11.3862L18.2391 6.3739C18.9979 6.04155 19.8825 6.38727 20.2149 7.14611L22.7736 12.9881C23.1059 13.7469 22.7602 14.6315 22.0014 14.9638L10.5573 19.9762C9.79844 20.3085 8.91386 19.9628 8.5815 19.204L6.02281 13.362Z",
    fill: "#FF8833"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7293 11.6131L7.29637 18.8105L6.69458 17.4365L23.1275 10.2391L23.7293 11.6131Z",
    fill: "#8D33FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3713 8.55969C19.6186 9.12447 19.3613 9.78283 18.7966 10.0302C18.2318 10.2776 17.5734 10.0202 17.3261 9.45547C17.0787 8.8907 17.336 8.23233 17.9008 7.98497C18.4656 7.73761 19.1239 7.99492 19.3713 8.55969Z",
    fill: "#8D33FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.14d22ea97033cb0a249f79d0b42fb033.svg";
export { ForwardRef as ReactComponent };